// extracted by mini-css-extract-plugin
export var externalLink = "_fa-0";
export var internalLinkLabel = "_fa-1";